<template>
  <modal @before-open="beforeOpen" @opened="opened" name="personalData" :clickToClose="true" :draggable="'.header'"
         :reset="true" :classes="['schedule','generalbox']"
         :adaptive="true"
         :height="'70%'" :width="'70%'" :max-width="1540" :min-width="1092" :min-height="614" :click-to-close="false">

    <div class="header">
      <h2>个人数据</h2>
      <div @click="close" class="close">
        <i class="iconfont icon-cha"></i>
      </div>
    </div>
    <div class="content">
      <h2>{{title}}详情</h2>
      <h2 class="nodata" v-if="noData">暂无数据</h2>
      <div v-if="!noData" :style="`bottom:${sizing?40:0}px`" ref="tableContainer" class="tableContainer">
        <v-table
            :row-click-color="'rgba(239,239,239,0.5)'"
            :row-click="selectRow"
            style="width:100%"
            :is-horizontal-resize="true"
            :column-cell-class-name="columnCellClass"
            :columns="columns"
            :table-data="tableData"
            :height="tableContentHeight"
            :show-vertical-border="false"
            ref="tableOverview"
        ></v-table>
      </div>
      <div v-if="sizing" class="pagination">
        <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="totalCount"
                      :pageIndex="pageNumber" :page-size="pageSize"
                      size="small"
                      :layout="['total', 'prev',  'pager','next', 'jumper']"
        ></v-pagination>
      </div>

    </div>

  </modal>
</template>

<script>
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'

  export default {
    name: "personalData",
    data() {
      return {
        columns: [],
        tableData: [],
        noData: false,
        title: null,
        tableContentHeight: 0,
        personalData: null,
        //分页相关
        sizing: false,
        pageNumber: 1,
        pageSize: null,
        totalCount: null

      }
    },
    computed: {},
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("personalData");
      },
      columnCellClass(rowIndex, columnName, rowData) {
        if (rowIndex % 2 !== 0) {
          return 'odd'
        }
      },
      //提交资料修改
      submitProfile() {

      },
      //初始化
      init() {
        this.noData = false;
        this.columns = [];
        this.tableData = [];
      },
      //获取个人数据详情
      async fetchPersonalDataDetail() {
        this.init()
        let personalDataDetail = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getPrivateDataDetail?id=" + this.personalData.id + '&pageNumber=' + this.pageNumber);
        if (!personalDataDetail.data.status) {
          this.noData = true;
          return;
        }
        personalDataDetail = personalDataDetail.data.data[0];

        //初始化页码信息
        this.sizing = personalDataDetail.needPager
        this.pageSize = personalDataDetail.pageSize
        this.totalCount = personalDataDetail.total

        //生成字段
        personalDataDetail.header.forEach((item, index) => {
          this.columns.push({
            field: index, title: item, width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true
          })

        })
        this.$nextTick(() => {
          this.$refs.tableOverview.tableResize()
        })


        //生成记录
        personalDataDetail.dataList.forEach((row, rIndex) => {
          let tempJson = {};
          row.forEach((col, cIndex) => {
            tempJson[cIndex] = col;
          });
          this.tableData.push(tempJson);
        })

      },
      async beforeOpen(data) {

        this.init();
        let personalData = data.params.personalData;
        this.personalData = personalData
        this.title = personalData.sysname;

        this.pageNumber = 1

        this.fetchPersonalDataDetail()
      },
      opened() {
        this.updateModalZIndex(this.$el)
        this.tableContentHeight = this.$refs.tableContainer.offsetHeight
      },
      selectRow() {

      },
      //分页相关
      pageChange(pageIndex) {
        this.pageNumber = pageIndex
        this.fetchPersonalDataDetail()
      },

      pageSizeChange(newPageSize) {

      }
    },
    mounted() {

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    & >>> ::-webkit-scrollbar {
      width: 10px;
      height: 12px;
    }

    & >>> ::-webkit-scrollbar-track-piece {
      background-color: rgba(0, 0, 0, 0.05);
      -webkit-border-radius: 10px;
    }

    & >>> ::-webkit-scrollbar-thumb:vertical {
      height: 10px;
      background-color: rgba(125, 125, 125, 0.7);
      -webkit-border-radius: 10px;
      z-index: 999999;
    }

    & >>> ::-webkit-scrollbar-thumb:horizontal {
      width: 10px;
      background-color: rgba(0, 0, 0, 0.4);
      -webkit-border-radius: 10px;
    }

  & > h2
    font-size 16px
    color #333333
    text-align center
    line-height 60px

  & > h2.nodata
    font-size 14px
    color #666666

  .tableContainer
    left 0
    right 0
    top 110px
    bottom 0
    overflow hidden
    position absolute

    & >>> .odd
      background-color #f1f1f1

    & >>> .v-checkbox-group
      padding-bottom 40px !important

  .pagination
    z-index 9
    position absolute
    bottom 0
    left 0
    right 0
    width 100%
    height 40px
    padding-top 10px

</style>



// WEBPACK FOOTER //
// src/components/personal/personalDataModal.vue